import { Loop } from '@widgets/Tool/Loop'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'

//Hearken widget is deprecated and replaced by Loop widget
const widget = {
  kind: ['widget', 'tool', 'hearken'],
  component: Loop,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
